export const ListAndDetailSamplesMultipleListsPageInfo = () => {
    return (
        <>
            This example shows how you can stack lists.<br />
            It also shows how you can auto collapse a list to give more space on the screen once another list is selected.<br />
            Use the fireCollapse prop to achieve this, look in the code how it is used.
        </>
    )
}
